import { Button, Typography } from '@material-tailwind/react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import RedeemCodePanel from '../components/RedeemCodePanel'
import UserDataPanel from '../components/UserDataPanel'
import { usePageTitle } from '../hooks/toolkit'

const Membership = () => {
  const { t } = useTranslation()
  usePageTitle('Membership | Agami')

  const [showRedeemUi, setShowRedeemUi] = useState(false)
  const [searchParams] = useSearchParams()
  const codeParam = searchParams.get('redeemCode')

  useEffect(() => {
    if (codeParam) {
      setShowRedeemUi(true)
    }
  }, [])

  return (
    <div className="w-11/12 mx-auto mt-12">
      <Typography variant="h1" className="text-primary dark:text-base-gray-400">
        {t('membership.title')}
      </Typography>

      <div className="w-full md:w-1/2 flex flex-col gap-4 dark:text-white">
        <UserDataPanel />
        {showRedeemUi ? (
          <RedeemCodePanel />
        ) : (
          <div className="mt-6">
            <Button size="sm" onClick={() => setShowRedeemUi(true)} data-testid="membership-upgrade-code-btn">
              {t('membership.upgradeCodeQuestion')}
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}

export default Membership
